export const MAX_FILES = 8;
export const MAX_FILE_SIZE = 15 * 1024 * 1024; // 15mb
export const MAX_TOTAL_FILE_SIZE = MAX_FILE_SIZE * MAX_FILES; // 15mb per image
export const FILE_GROUP_NAME = 'file';
